import { PHONE, locationSchema } from "../structured-data-core";

export function getDenverStructuredData() {
  const url = "https://restorehair.com/locations/restore-denver/";
  const description =
    "Restore your confidence with the top hair restoration team serving Denver and the surrounding Colorado metro. Over 20,000 procedures.";
  return [
    locationSchema("Boulder", "4770 Baseline Rd, Office 232", "Boulder", "CO", PHONE, url, description),
    locationSchema("Colorado Springs", "102 S Tejon St", "Colorado Springs", "CO", PHONE, url, description),
    locationSchema("Denver – Downtown", "2301 Blake St, Suite 113", "Denver", "CO", PHONE, url, description),
    locationSchema("Greenwood Village", "5445 DTC Pkwy, Suite 1015", "Greenwood Village", "CO", PHONE, url, description),
  ];
}
